import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  justify-content: center;
  margin: 6px 10px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
`;

export const Card = styled.div<{ needToRed: boolean; isTitle: boolean }>`
  display: flex;
  flex-direction: column;
  border: ${({ theme, needToRed, isTitle }) => {
    if (isTitle) {
      return `none`;
    }
    if (needToRed) {
      return `1px solid ${theme.colors.RED}`;
    }

    return `0px solid #ececec`;
  }};

  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.WHITE};
  min-height: 80px;
  padding: 20px 20px 30px 20px;
  box-sizing: border-box;
`;

/* 헤더 이미지와 타이틀 사이의 공간 수정 */
export const HeightSpace = styled.div`
  // height: 140px;
  border-radius: 8px 8px 0 0; /* 위쪽 두 모서리만 라운드 */
`;

// 섹션 위에 이미지 수정
export const TitleHighlight = styled.div<{ image: string }>`
  background-image: url(${({ image }) => image});
  background-size: cover; /* 이미지 크기 조정 */
  background-position: center; /* Centers the image */
  background-repeat: no-repeat; /* 이미지 반복 방지 */
  position: relative;
  width: calc(100% + 40px);
  margin: -20px -20px 20px -20px;
  height: 140px;
  z-index: 21;
  border-radius: 8px 8px 0 0; /* 위쪽 두 모서리만 라운드 */
`;

export const RequiredSection = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 30px;
`;

export const RequiredSpan = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.RED};
`;

export const LengthMinSection = styled.div`
  display: flex;
  position: absolute;
  align-items: flex-end;
  height: 30px;
  right: 40px;
  bottom: 8px;
`;

export const CurrentLengthSpan = styled.span<{ isUnder: boolean }>`
  font-size: 11px;
  color: ${({ theme, isUnder }) => (isUnder ? theme.colors.RED : "black")};
`;

export const LengthMinSpan = styled.span`
  font-size: 11px;
  color: black;
`;
